import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const manageAlarmsReducer: AppReducer<'ManageAlarms'> = (
    state = InitialState.ManageAlarms,
    action
): typeof state => {
    switch (action.type) {
        case 'AlarmsFilters/Save/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
            };
        case 'AlarmsFilters/Save/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };
        case 'AlarmsFilters/Save/Unmounted':
            return {
                ...state,
                loading: false,
                success: false,
            };
        case 'AlarmsFilters/Save/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload.errorCode,
            };
            case 'AlarmsFilters/Update/Succeeded':
                return {
                    ...state,
                    loading: false,
                    success: true,
                };
            case 'AlarmsFilters/Update/Started':
                return {
                    ...state,
                    loading: true,
                    success: false,
                };
            case 'AlarmsFilters/Update/Unmounted':
                return {
                    ...state,
                    loading: false,
                    success: false,
                };
            case 'AlarmsFilters/Update/Failed':
                return {
                    ...state,
                    loading: false,
                    success: false,
                    error: action.payload.errorCode,
                };
        case 'DeviceChannel/Count/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
            };
        case 'DeviceChannel/Count/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };
        case 'DeviceChannel/Count/Unmounted':
            return {
                ...state,
                loading: false,
                success: false,
            };
        case 'DeviceChannel/Count/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload.errorCode,
            };
        case 'ManageAlarms/SetAlarmFilters':
            return {
                filters: {
                    locationId: action.payload.filtersData.locationId,
                    siteId: action.payload.filtersData.siteId,
                    deviceType: action.payload.filtersData.deviceType,
                    gatewayId: action.payload.filtersData.gatewayId,
                    gatewayTypeId: action.payload.filtersData.gatewayTypeId,
                    type: action.payload.filtersData.type,
                    alarmType: action.payload.filtersData.alarmType,
                },
                loading: false,
                success: false,
                configLoading:false,
                configSuccess:false,
                error: '',
                            };
        case 'ManageAlarms/SetSelectedDeviceId':
            return {
                ...state,
                selectedDevice: action.payload.deviceId,
                loading: false,
                success: false,
                error: '',
            };
        case 'AlarmsConfig/Save/Succeeded':
            return {
                ...state,
                configLoading: false,
                configSuccess: true,
            };
        case 'AlarmsConfig/Save/Started':
            return {
                ...state,
                configLoading: true,
                configSuccess: false,
            };
        case 'AlarmsConfig/Save/Unmounted':
            return {
                ...state,
                configLoading: false,
                configSuccess: false,
            };
        case 'AlarmsConfig/Save/Failed':
            return {
                ...state,
                configLoading: false,
                configSuccess: false,
                error: action.payload.errorCode,
            };
        default:
            return state;
    }
};
